import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
    isSelected?: boolean;
  }

interface IColorRectProps {
    bgcolor?: string;
    first?: boolean;
    last?: boolean;
}

export const Root = styled.div`
   margin-top: 6px;
`;

export const ButtonContainer = styled.div`
  display:flex;
  flex-direction: column;
  width: 36px;
  height: 31px;
  align-items: center;
  justify-content: flex-end;
  border-radius: 5px;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;

export const ColorRect = styled.div`
    width: 24px;
    height: 5px;
    margin: 3px 0px 1px 0px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
`;

export const ColorSection = styled.div`
    height: 5px;
    width: 100%;
    background-color: ${(props: IColorRectProps) => props.bgcolor ?? "#000000"};
    border-top-left-radius: ${(props: IColorRectProps) => props.first ? "5px":""};
    border-bottom-left-radius: ${(props: IColorRectProps) => props.first ? "5px":""};
    border-top-right-radius: ${(props: IColorRectProps) => props.last ? "5px":""};
    border-bottom-right-radius: ${(props: IColorRectProps) => props.last ? "5px":""};
`;